import api from '../services/api';
import { Dispatch } from 'redux';
import { StoreState } from '../types/state';

export const AUTH_ACTIONS = {
  INITIALIZE: 'INITIALIZE',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_ERROR: 'FORGOT_PASSWORD_ERROR',
  LOGOUT: 'LOGOUT',
  VALIDATING_TOKEN: 'VALIDATING_TOKEN', //this is for the reset-password token validation
  VALIDATE_TOKEN_FAIL: 'VALIDATE_TOKEN_FAIL',
  VALIDATE_TOKEN_SUCCESS: 'VALIDATE_TOKEN_SUCCESS',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERROR: 'RESET_PASSWORD_ERROR',
  LOGIN_ERROR: 'LOGIN_ERROR',
  AUTH_ERROR: 'AUTH_ERROR',
  VALIDATING_AUTH_TOKEN: 'VALIDATING_AUTH_TOKEN',
  VAlIDATE_AUTH_TOKEN_SUCESS: 'VAlIDATE_AUTH_TOKEN_SUCESS',
  EMAIL_SIGNIN_LINK_CREATE_SUCCESS: 'EMAIL_SIGNIN_LINK_CREATE_SUCCESS',
  EMAIL_SIGNIN_LINK_CREATE_FAIL: 'EMAIL_SIGNIN_LINK_CREATE_FAIL',
  EMAIL_SIGNIN_LINK_RESET: 'EMAIL_SIGNIN_LINK_RESET',
  EMAIL_SIGNIN_LINK_LOGIN_SUCCESS: 'EMAIL_SIGNIN_LINK_LOGIN_SUCCESS',
  EMAIL_SIGNIN_LINK_LOGIN_ERROR: 'EMAIL_SIGNIN_LINK_LOGIN_ERROR',
  SIGNUP_ENTRATA_USER: 'SIGNUP_ENTRATA_USER',
  GET_LINKED_CLIENTS: 'GET_LINKED_CLIENTS',
  GET_CURRENT_CLIENT: 'GET_CURRENT_CLIENT',
  IS_LOADING: 'IS_LOADING',
};
export const setLoading = (dispatch: Dispatch, isLoading: boolean) =>
  dispatch({
    type: AUTH_ACTIONS.IS_LOADING,
    payload: isLoading,
  });

type Credentials = {
  username: string;
  password: string;
};

export const login = (credentials: Credentials) => (dispatch: Dispatch) => {
  dispatch({
    type: AUTH_ACTIONS.IS_LOADING,
    payload: true,
  });
  return api
    .login(credentials)
    .then(async (res) => {
      let values = res.data;

      try {
        const linkedClients = await api.getLinkedClients();

        dispatch({
          type: AUTH_ACTIONS.GET_LINKED_CLIENTS,
          payload: linkedClients.data,
          meta: {
            track: true,
          },
        });
      } catch (err) {
        console.log('Error :', err.message);
        throw err;
      }

      dispatch({
        type: AUTH_ACTIONS.LOGIN_SUCCESS,
        payload: values,
        meta: {
          initialize: process.env.REACT_APP_MIXPANEL_TOKEN,
          track: true,
          identify: values ? values.user : null,
          register: values ? values : null,
        },
      });
    })
    .catch((err) => {
      console.log('Error :', err.message);
      if (err.response) {
        dispatch({
          type: AUTH_ACTIONS.LOGIN_ERROR,
          payload: { error: err.response.data.error },
          meta: {
            track: true,
          },
        });
      }
    })
    .finally(() => {
      dispatch({
        type: 'IS_LOADING',
        payload: false,
      });
    });
};

export const forgotPassword = (data: any) => (dispatch: Dispatch) => {
  dispatch({
    type: AUTH_ACTIONS.IS_LOADING,
    payload: true,
  });
  api
    .forgotPassword(data)
    .then((res) => {
      dispatch({
        type: AUTH_ACTIONS.FORGOT_PASSWORD_SUCCESS,
        payload: res.data,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: AUTH_ACTIONS.FORGOT_PASSWORD_ERROR,
          payload: err.response.data,
          meta: {
            track: true,
          },
        });
      }
    })
    .finally(() => {
      dispatch({
        type: AUTH_ACTIONS.IS_LOADING,
        payload: false,
      });
    });
};

export const resetPassword = (data: any) => (dispatch: Dispatch) => {
  dispatch({
    type: 'IS_LOADING',
    payload: true,
  });
  api
    .resetPassword(data)
    .then((res) => {
      let values = res.data;
      dispatch({
        type: AUTH_ACTIONS.RESET_PASSWORD_SUCCESS,
        payload: values,
        meta: {
          initialize: process.env.REACT_APP_MIXPANEL_TOKEN,
          track: true,
          identify: values ? values.user : null,
          register: values,
        },
      });
    })
    .catch((err) => {
      console.log(err.response);
      dispatch({
        type: AUTH_ACTIONS.RESET_PASSWORD_ERROR,
        payload: err.response.data,
        meta: {
          track: true,
        },
      });
    })
    .finally(() => {
      dispatch({
        type: 'IS_LOADING',
        payload: false,
      });
    });
};

export const logout = () => (dispatch: Dispatch, getStore: any) => {
  const store: StoreState = getStore();
  if (store.auth.isAuthenticated) {
    dispatch({
      type: 'LOGOUT',
      meta: {
        track: true,
      },
    });

    api
      .logout()
      .then(() => {})
      .catch((err) => {
        dispatch({
          type: 'LOGOUT_FAILURE',
          meta: {
            track: true,
          },
        });
      });
  }
};

export const switchClient =
  (selectedClientId: number) => (dispatch: Dispatch) => {
    api
      .switchClient(selectedClientId)
      .then((res) => {
        let values = res.data;

        dispatch({
          type: AUTH_ACTIONS.VAlIDATE_AUTH_TOKEN_SUCESS,
          payload: values,
        });

        window.location.href = '/';
      })
      .catch((error) => console.log('Could not change PMS', error));
  };

export const getLinkedClients = () => (dispatch: Dispatch) => {
  api
    .getLinkedClients()
    .then((res) => {
      dispatch({
        type: AUTH_ACTIONS.GET_LINKED_CLIENTS,
        payload: res.data,
      });
    })
    .catch((error) =>
      console.log('Error fetching linked clients: ', error.message)
    );
};

export const getCurrentClient = () => (dispatch: Dispatch) => {
  api
    .getCurrentClient()
    .then((res) => {
      dispatch({
        type: AUTH_ACTIONS.GET_CURRENT_CLIENT,
        payload: res.data,
      });
    })
    .catch((error) =>
      console.log('Error fetching linked clients: ', error.message)
    );
};

export const validateToken = (token: string) => (dispatch: Dispatch) => {
  dispatch({
    type: 'IS_LOADING',
    payload: true,
  });
  api
    .validateToken(token)
    .then(() => {
      dispatch({
        type: AUTH_ACTIONS.VALIDATE_TOKEN_SUCCESS,
        meta: {
          track: true,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: AUTH_ACTIONS.VALIDATE_TOKEN_FAIL,
        meta: {
          track: true,
        },
      });
    })
    .finally(() => {
      dispatch({
        type: 'IS_LOADING',
        payload: false,
      });
    });
};

export const initialize = () => (dispatch: Dispatch, getStore: any) => {
  dispatch({
    type: AUTH_ACTIONS.VALIDATING_AUTH_TOKEN,
    payload: true,
  });
  api
    .validateAuthToken()
    .then((res) => {
      dispatch({
        type: AUTH_ACTIONS.VAlIDATE_AUTH_TOKEN_SUCESS,
        payload: res.data,
        meta: {
          initialize: process.env.REACT_APP_MIXPANEL_TOKEN,
          identify: res.data.user,
          register: res.data,
        },
      });
    })
    .catch((err) => {
      logout()(dispatch, getStore);
    })
    .finally(() => {
      dispatch({
        type: AUTH_ACTIONS.VALIDATING_AUTH_TOKEN,
        payload: false,
      });
    });
};

export const validateAuthToken = () => (dispatch: Dispatch, getStore: any) => {
  const store: StoreState = getStore();
  if (store.auth.isAuthenticated) {
    api
      .validateAuthToken()
      .then((res) => {
        console.log('validate', res.data);
        dispatch({
          type: AUTH_ACTIONS.VAlIDATE_AUTH_TOKEN_SUCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        logout()(dispatch, getStore);
      });
  }
};

export const emailLoginLink = (email: string) => (dispatch: Dispatch) => {
  return api
    .emailLoginLink(email)
    .then(() => {
      dispatch({
        type: AUTH_ACTIONS.EMAIL_SIGNIN_LINK_CREATE_SUCCESS,
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: AUTH_ACTIONS.EMAIL_SIGNIN_LINK_CREATE_FAIL,
          payload: { error: err.response.data.error },
        });
      }
    });
};

export const magicLinkSignIn = (token: string) => (dispatch: Dispatch) => {
  api
    .magicLinkSignIn(token)
    .then((res) => {
      let values = res.data;
      dispatch({
        type: AUTH_ACTIONS.EMAIL_SIGNIN_LINK_LOGIN_SUCCESS,
        payload: values,
        meta: {
          track: true,
          identify: values ? values.user : null,
          register: values ? values : null,
        },
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: AUTH_ACTIONS.EMAIL_SIGNIN_LINK_LOGIN_ERROR,
          payload: { error: err.response.data.error },
        });
      }
    });
};

export const emailSignInReset = () => (dispatch: Dispatch) =>
  dispatch({
    type: AUTH_ACTIONS.EMAIL_SIGNIN_LINK_RESET,
  });
export const validateEntrataAuthCode =
  (authCode: string) => (dispatch: Dispatch, getStore: any) => {
    if (authCode) {
      dispatch({
        type: AUTH_ACTIONS.VALIDATING_AUTH_TOKEN,
        payload: true,
      });
      api
        .validateAuthCode('entrata', authCode)
        .then((res) => {
          if (!res.data.isFirstLogin) {
            dispatch({
              type: AUTH_ACTIONS.VAlIDATE_AUTH_TOKEN_SUCESS,
              payload: res.data,
              meta: {
                track: true,
              },
            });
          } else {
            dispatch({
              type: AUTH_ACTIONS.VALIDATING_AUTH_TOKEN,
              payload: false,
            });
            dispatch({
              type: AUTH_ACTIONS.SIGNUP_ENTRATA_USER,
              payload: res.data,
              meta: {
                track: true,
              },
            });
          }
        })
        .finally(() => {
          dispatch({
            type: AUTH_ACTIONS.VALIDATING_AUTH_TOKEN,
            payload: false,
          });
        });
    } else {
      logout()(dispatch, getStore);
    }
  };

export const signUpEntrataUser =
  (values: {
    username: string;
    password: string;
    entrataUserId: string;
    clientId: number;
  }) =>
  (dispatch: Dispatch) => {
    api
      .entrataUserSignUp(values)
      .then((res) => {
        dispatch({
          type: AUTH_ACTIONS.LOGIN_SUCCESS,
          payload: res.data,
        });
        dispatch({
          type: AUTH_ACTIONS.SIGNUP_ENTRATA_USER,
        });
      })
      .catch((err) => {
        dispatch({
          type: AUTH_ACTIONS.AUTH_ERROR,
          payload: err.response.data.error,
        });
      });
  };
